export enum ContractTypeCode {
  SERVICE = 'service',
  RENTING = 'renting',
  PRECARIOUS_LEASE = 'precarious_lease',
  BAIL_369 = '369',
  BAIL_DEROGATOIRE = 'bail_derogatoire',
  OTHER = 'other',
}

export type ContractType = {
  code: ContractTypeCode,
}
